import { addSlashes, getHeroBackground } from 'utils/cms/utils';
import { mapCustomiseRegion } from 'utils/cms/mapHomeEnt';
import { sortObjectByOrder } from 'utils/utils';
import { getReleaseMessaging } from 'utils/releaseMessaging';

function getEnabledViews(data) {
	const tabs = data.pages?.home?.previewPanelTabs;
	const pages = data?.pages;
	const homeEntSections = pages?.homeEnt?.active ? sortObjectByOrder(pages?.homeEnt?.sections, (val, key) => `boltHomeEnt:${key}`) : [];
	const hasShowtimes = pages?.showtimes?.active;
	return [
		...homeEntSections,
		hasShowtimes && 'boltShowtimes',
	].filter((key, index) => {
		if (!key) return false;
		const manualSelection = tabs?.[key];
		if (manualSelection != undefined) return manualSelection;
		return index === 0 || (!hasShowtimes && index === 1) || key === 'boltShowtimes';
	});
}

export default function mapPreviewPanel(cmsData, appData) {
	if (!appData?.pages?.boltPreviewPanel) return null;

	const homeData = cmsData?.pages?.home;
	if (homeData?.heroMode !== 'preview') return null;

	const isDefault = homeData?.settings?.default ?? true;
	const release = homeData.releaseMessaging;
	const secondaryButton = homeData.previewPanelSecondaryButton;

	return {
		disabled: false,
		data: {
			bg: getHeroBackground(cmsData),
			extraButton: secondaryButton?.enabled ? { ...secondaryButton, position: 'bottom' } : null,
			releaseMessaging: (release?.enabled ?? true) ? (release?.text ?? getReleaseMessaging(cmsData)) : null,
			tt: { desktop: homeData.tt?.url, alt: homeData.tt?.alt },
			enabledViews: getEnabledViews(cmsData).join(','),
			customiseRegion: mapCustomiseRegion(cmsData),
		},
		path: isDefault ? '/' : '/home/',
		alternatePaths: addSlashes(homeData.path),
		isMainPage: isDefault,
	};
}